
















































































import Vue from 'vue';

export default Vue.extend({
    name: 'HelpPdfDesigner',
    created() {
        this.$store.state.routeLoaded = true;
    }
})
